import React from 'react';
import { StickyTabNavigation } from 'src/components/sticky-tab-nav';
import { useNavigationLinks } from './utils';

export const ProductNavigation: React.FC = () => {
  const navigationTabs = useNavigationLinks();

  return (
    <StickyTabNavigation
      defaultActiveTabId={navigationTabs[0].id}
      tabs={navigationTabs}
      background
    />
  );
};
